// extracted by mini-css-extract-plugin
export default {"options_parent":"SearchBar_options_parent__ah6yR","options_box":"SearchBar_options_box__g66wt"};